<template>
    <div>
      <el-dialog :visible.sync="centerDialogVisible" title="激活电子教材" top="20vh" width="480px" center :close-on-click-modal=false :close-on-press-escape=false>
        <div class="content">
          <el-input class="activation" v-model="activationInput" placeholder="请输入8位激活码" maxlength="8"> </el-input>
          <div class="tips">
            {{tipText}}
          </div>
          <div class="txt">
            <div>说明：</div>
            <div>1.电子教材为出版社正规授权，请激活后使用；</div>
            <div>2.激活码获取，请扫描下方二维码</div>
          </div>
          <div class="teacher-code">
            <img src="@/assets/teacher_code.jpg" alt="">
          </div>
          <el-button class="sure-bind" type="primary"  :disabled="bindBtnDisabled" @click="activateVersion">提交</el-button>
        </div>
      </el-dialog>
  </div>
</template>
<script>
import api from '../utils/api.js'
export default {
  name: 'EbookActivationDialog',
  data () {
    return {
      centerDialogVisible: false,
      bindBtnDisabled: false,
      activationInput: '',
      tipText: ''
    }
  },
  watch: {
    'activationInput' () {
      this.tipText = ''
    },
    'centerDialogVisible' (show) {
      if (show === false) {
        this.activationInput = ''
      }
    }
  },
  methods: {
    showDialog (vipStatus) {
      if (vipStatus === 3) {
        this.tipText = '激活码已过期，请重新激活'
      }
      this.centerDialogVisible = true
    },
    activateVersion () {
      let code = this.activationInput
      if (!code) {
        this.tipText = '验证码不能为空'
      } else if (code.length < 8) {
        this.tipText = '请确认激活码的位数'
      } else {
        api.post('ActivateVersionRequest', {
          code: code,
          type: 2
        }, res => {
          if (res.body.activeStatus === 1) {
            this.$message({
              message: '成功激活' + res.body.versionName + '电子教材',
              type: 'success'
            })
            this.afterActive()
          } else {
            this.tipText = '激活码无效'
          }
        }, res => {
          if (res.result.retCode === 3000301) {
            this.tipText = '激活码无效'
          }
        })
      }
    },
    afterActive () {
      this.centerDialogVisible = false
      this.$emit('afterActive')
    }
  }
}
</script>
<style scoped lang="scss">
.content {
  width: 300px;
  margin-left: 68px;
}
.activation{
  width: 300px;
}
.sure-bind{
  width: 300px;
}
.txt{
  text-align: left;
  padding-top: 10px;
  div{
      line-height: 1.5;
      font-weight: 500;
  }
}
.tips {
  line-height: 1.6;
  color: #f43530;
}
.teacher-code{
  padding-top: 10px;
  text-align: center;
  img{
      height: 111px;
      width: 111px;
  }
}
</style>
